<template>
  <div v-if="getBalance[currency] && getCurrency[currency]">
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ getCurrency[currency].name }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
        <div class="right">
          <router-link to="/deposithistory">
            {{ $t("History") }}
          </router-link>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn">
      <div class="text-center">
        <div class="coin m-b-md">
          <div class="animated bounceIn infinite">
            <img :src="require(`@/assets/tokens/${currency}.png`)" />
          </div>

          <h3 class="m-t-md">
            {{ getBalance[currency].balance }} {{ currency }}<br />
            <small v-if="getCoins[currency]"
              >≈ $
              {{
                usd(
                  getCoins[currency].last_price * getBalance[currency].balance
                )
              }}</small
            >
          </h3>
          <a
            v-bind:href="getCurrency[currency].website"
            target="_blank"
            class="border-right"
          >
            Website</a
          ><a
            v-bind:href="getCurrency[currency].explorer"
            target="_blank"
            class="m-l-xs"
          >
            Explorer
          </a>
        </div>
      </div>

      <table class="table table-condensed">
        <tbody>
          <tr>
            <td>
              {{ $t("Totalbalance") }}
            </td>
            <td class="text-right font-bold">
              {{ getBalance[currency].balance }}
              {{ currency }}
            </td>
          </tr>
          <tr>
            <td>{{ $t("Inorder") }}</td>
            <td class="text-right font-bold">
              {{ getBalance[currency].inorder }}
              {{ currency }}
            </td>
          </tr>
          <tr>
            <td>{{ $t("Instaking") }}</td>
            <td class="text-right font-bold">
              {{ getBalance[currency].instaking }}
              {{ currency }}
            </td>
          </tr>
          <tr>
            <td>{{ $t("Availablebalance") }}</td>
            <td class="text-right font-bold">
              <span class="c-accent"
                >{{ getBalance[currency].available }} {{ currency }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div
          v-if="
            getCurrency[currency].type == 'ENABLED' ||
              getCurrency[currency].type == 'DEPOSIT_ONLY'
          "
        >
          <div class="col-xs-6 col-sm-3 m-t-sm">
            <router-link
              v-bind:to="'/deposit/' + currency"
              class="btn btn-accent btn-block text-accent"
              tag="button"
            >
              <span
                data-v-7cd4f6cb=""
                class="m-t-xs fad fa-donate fa-2x"
              ></span>
              <p>{{ $t("Deposit") }}</p>
            </router-link>
          </div>
        </div>
        <div
          v-if="
            getCurrency[currency].type == 'ENABLED' ||
              getCurrency[currency].type == 'WITHDRAW_ONLY'
          "
        >
          <div class="col-xs-6 col-sm-3 m-t-sm">
            <router-link
              v-bind:to="'/withdraw/' + currency"
              class="btn btn-accent btn-block text-accent"
              tag="button"
            >
              <span
                data-v-7cd4f6cb=""
                class="m-t-xs fad fa-paper-plane fa-2x"
              ></span>
              <p>{{ $t("Withdrawal") }}</p>
            </router-link>
          </div>
        </div>

        <div
          v-if="
            getCurrency[currency].type == 'ENABLED' ||
              getCurrency[currency].type == 'TRANSFER_ONLY' ||
              getCurrency[currency].type == 'WITHDRAW_ONLY' ||
              getCurrency[currency].type == 'DEPOSIT_ONLY'
          "
        >
          <div class="col-xs-6 col-sm-3 m-t-sm">
            <router-link
              v-bind:to="'/receive'"
              class="btn btn-accent btn-block text-accent"
              tag="button"
            >
              <span
                data-v-7cd4f6cb=""
                class="m-t-xs fad fa-qrcode fa-2x"
              ></span>
              <p>{{ $t("Receive") }}</p>
            </router-link>
          </div>
          <div class="col-xs-6 col-sm-3 m-t-sm">
            <router-link
              v-bind:to="'/transfer/' + currency"
              class="btn btn-accent btn-block text-accent"
              tag="button"
            >
              <span
                data-v-7cd4f6cb=""
                class="m-t-xs fad fa-exchange-alt fa-2x"
              ></span>
              <p>{{ $t("Transfer") }}</p>
            </router-link>
          </div>
        </div>
      </div>

      <h4 class="m-t-md">{{ $t("GoToTrade") }}</h4>
      <div class="row">
        <div v-for="m in getMarket" v-bind:key="m.id">
          <router-link
            v-bind:to="'/' + getSitemode + '/' + m.pair"
            class="col-xs-6"
            tag="div"
            v-if="m.secondary === currency || m.primary === currency"
          >
            <div class="marketbox pointer">
              <div class="">
                <span class="c-white">{{ m.secondary }} / {{ m.primary }}</span>
                <br />
              </div>

              <div v-if="m.primary === 'USDT' || m.primary === 'DAI'">
                <span class="font-bold c-white">{{ m.last_price }}</span>
                <span class="m-l-xs text-buy" v-if="m.change / 1 >= 0">
                  +{{ m.change }}%
                </span>
                <span class="m-l-xs text-sell" v-else> {{ m.change }}% </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import func from "@/widgets/func";

export default {
  data() {
    return {
      currency: this.$route.params.currency,
    };
  },
  computed: mapGetters([
    "getBalance",
    "getCurrency",
    "getMarket",
    "getCoins",
    "getSitemode",
  ]),
  methods: {
    amount(a) {
      return func.fixed8(a);
    },
    usd(a) {
      return func.fixed2(a);
    },
  },
};
</script>

<style scoped>
/* WAIT MARKET */
.marketbox {
  padding: 10px;
  margin-bottom: 6px;
  background-color: rgba(68, 70, 79, 0.5);
}
.border-right {
  border-right: 2px solid #949ba2;
  padding-right: 5px;
}
</style>
